import { render, staticRenderFns } from "./chaseDialog.vue?vue&type=template&id=6957a054&scoped=true"
import script from "./chaseDialog.vue?vue&type=script&lang=js"
export * from "./chaseDialog.vue?vue&type=script&lang=js"
import style0 from "./chaseDialog.vue?vue&type=style&index=0&id=6957a054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957a054",
  null
  
)

export default component.exports